import { render, staticRenderFns } from "./TextValue.vue?vue&type=template&id=0295e9c6&"
import script from "./TextValue.vue?vue&type=script&lang=js&"
export * from "./TextValue.vue?vue&type=script&lang=js&"
import style0 from "./TextValue.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports